import React, { useEffect, useState } from 'react'

//Utils
import { CustomFetch } from '../../../Utils/CustomFetch'
import { ProductsData } from '../../../Data/ProductsData'
import ProductsList from '../ProductsList/ProductsList'

//Components

const ProductsListContainer = () => {

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(false)
    CustomFetch(ProductsData)
      .then(res => {
        setData(res)
        setLoading(true)
      })
  }, [])

  return (
    <>
      {
        loading
          ?
          <ProductsList data={data} setData={setData} />
          :
          <>Loading...</>
      }
    </>
  )
}

export default ProductsListContainer